import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import { yellow } from "@material-ui/core/colors";
import { Menu } from 'antd'
import { StarFilled, CloudFilled, CheckCircleFilled, UserOutlined, FileTextOutlined } from '@ant-design/icons'


const styles = (theme) => ({
  drawer: {
    position: "relative",
    width: "208px",
    height: "100%",
    boxShadow: "2px 0px 6px 0px rgba(0, 21, 41, 0.35)",
    borderRight: "none",
    backgroundColor: '#fff'
  },
  menuTitle: {
    padding: '6px 10px',
  },
  menuTitleText: {
    padding: '5px 10px',
    borderBottom: '1px solid #eee',
    fontSize: '16px',
    color: '#000',
    lineHeight: '30px'
  }
});

export class Left extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
  };

  state = {
    selectKeys: [],
    openKeys: []
  }

  componentDidMount() {  
    let isHistory = sessionStorage.getItem('toHistory')
    if (isHistory == '1') {
      sessionStorage.setItem('toHistory', '0')
      this.setState({
        selectKeys: ['3-1'],
        openKeys: ['3']
      })
    } else {
      this.setState({
        selectKeys: ['1']
      })
    }
  }

  render() {
    const classes = this.props.classes;
    const menuList = [
      {
        key: '1',
        label: "个人信息",
        icon: <UserOutlined/>,
        path: "/userCenter/userInfo",
        id: 'userinfo'
      },
      {
        key: '2',
        label: "我的收藏",
        icon: <StarFilled/>,
        id: 'my-collect',
        children: [
          {
            key: '2-1',
            label: "法律法规",
            path: "/userCenter/collectLaw"
          },
          {
            key: '2-2',
            label: "海外法规",
            path: "/userCenter/collectFDA"
          },
        ]
      },
      {
        key: '3',
        label: "我的翻译",
        icon: <FileTextOutlined/>,
        children: [
          {
            key: '3-1',
            label: "法律法规",
            path: "/userCenter/translateLaw"
          },
          {
            key: '3-2',
            label: "海外法规",
            path: "/userCenter/translateFDA"
          },
        ]
      },
      {
        key: '4',
        label: "订阅中心",
        icon: <CheckCircleFilled/>,
        id: 'my-subscribe',
        children: [
          {
            key: '4-1',
            label: "法律法规",
            path: "/userCenter/subscribeLaw"
          },
          {
            key: '4-2',
            label: "海外法规",
            path: "/userCenter/subscribeFDA"
          },
        ]
      },
      // {
      //   key: '5',
      //   label: "浏览记录",
      //   icon: <CloudFilled/>,
      //   path: "/userCenter/log",
      // },
    ];

    const onClick = ({keyPath}) => {
      let path = ''
      if (keyPath.length > 1) {
        let item = menuList.find(v => {
          return v.key == keyPath[1]
        })
        let childrenItem = item.children.find(v => {
          return v.key == keyPath[0]
        })
        path = childrenItem.path
      } else {
        let item = menuList.find(v => {
          return v.key == keyPath[0]
        })
        path = item.path
      }

      this.props.history.push(path)
    }

    return (
      <div className={classes.drawer}>
        <div className={classes.menuTitle}>
          <div className={classes.menuTitleText}>
            用户中心
          </div>
        </div>
        <div className={classes.menuBox}>
          {
            this.state.selectKeys.length > 0 && 
            <Menu
              onClick={onClick}
              style={{ width: 208 }}
              defaultSelectedKeys={this.state.selectKeys}
              defaultOpenKeys={this.state.openKeys}
              mode="inline"
              items={menuList}
            />
          }
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Left));
